import {Injectable} from '@angular/core'

import {Observable} from 'rxjs'
import {map} from 'rxjs/operators'

import {SearchFilter} from '@app/core/services/search/search-filter.interface'
import {
  GenericListService,
  LoadRequest,
  LoadResult,
} from '../generic-list.service'
import {Role, RoleService, GetRolesRequest} from '@app/core/services/rest-api'
import {NotificationService} from '@app/core/services/notification.service'
import {LoggerService} from '@app/core/services/logger.service'
import {ContextService} from '@app/core/services/context.service'

@Injectable()
export class RoleListService extends GenericListService<Role> {
  filter: SearchFilter = null

  constructor(
    private roleSvc: RoleService,
    protected notify: NotificationService,
    protected contextSvc: ContextService,
    protected logger: LoggerService,
  ) {
    super(notify, logger)
  }

  retrieve(request: LoadRequest): Observable<LoadResult<Role>> {
    // build the service request
    const svcRequest: GetRolesRequest = {
      domain: request.domain,
      offset: request.offset,
      results: request.count,
    }

    if (this.filter) {
      svcRequest.search = this.filter.query
      svcRequest.sort = this.filter.sort
      svcRequest.asc = this.filter.asc
    }

    return this.roleSvc.getRoles(svcRequest).pipe(
      map((res) => {
        const result: LoadResult<Role> = {
          total: res.count,
          items: res.results,
        }
        return result
      }),
    )
  }
}
